// for additional global typography props
export const typographyTheme = {
  typography: {
    fontFamily: 'Hurme Geometric Sans 4',
  },
};
